import React from "react";
import ReactDOM from "react-dom/client";

import { GlobalStyles } from "./Global/GlobalStyles";
import { ThemeProvider } from "styled-components";
import { Theme } from "./Global/Theme";
import { Home } from "./components/Pages/Home";
import { Route, Routes, BrowserRouter, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { ContextProvider } from "./context/Context";
import { Offline } from "./components/Pages/Offline";
import { Scheduling } from "./components/Pages/Scheduling";
import { PageBaseTemplate } from "./components/Templates/PageBaseTemplate";
import { Store } from "./components/Pages/Store";
import { Residence } from "./components/Pages/Residence";
import { LoginRegister } from "./components/Pages/LoginRegister";
import { Login } from "./components/Pages/Login";
import { Register } from "./components/Pages/Register";
import { Services } from "./components/Pages/Services";
import { Survey } from "./components/Pages/Survey";
import { License } from "./components/Pages/License";
import { Vehicle } from "./components/Pages/Vehicle";
import { AddressRegistration } from "./components/Pages/AddressRegistration";
import { Payment } from "./components/Pages/Payment";
import { Pix } from "./components/Pages/Pix";
import { Ticket } from "./components/Pages/Ticket";
import { ScheduleList } from "./components/Pages/ScheduleList";
import { SchedulingDetail } from "./components/Pages/SchedulingDetail";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import { ProtectedRoute } from "./components/Atoms/ProtectedRoute";
import { ProtectedClientRoute } from "./components/Atoms/ProtectedClientRoute";
import { TermsOfUse } from "./components/Pages/TermsOfUse";
import { PrivacyPolicy } from "./components/Pages/PrivacyPolicy";
import { Complaint } from "./components/Pages/complaint/complaint";
import { WorkWithUs } from "./components/Pages/ workWithUs/ workWithUs";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const RedirectToLoginCadastro: React.FC = () => {
  window.location.replace(
    "https://mapa.veloxvistorias.com/agendamento/login-cadastro",
  );
  return null;
};
const RedirectToAgendamento: React.FC = () => {
  window.location.replace("https://mapa.veloxvistorias.com/agendamento");
  return null;
};

root.render(
  <React.StrictMode>
    <ThemeProvider theme={Theme}>
      <ToastContainer autoClose={3000} />
      <GlobalStyles />
      <ContextProvider>
        <BrowserRouter>
          <Routes>
            {/* <Route path="/" element={<Navigate to={"/offline"} />} /> */}
            <Route index element={<Home />} />
            <Route path="politica-de-privacidade" element={<PrivacyPolicy />} />
            <Route path="trabalhe-conosco" element={<WorkWithUs />} />
            <Route path="termos-de-uso" element={<TermsOfUse />} />
            <Route path="denuncia" element={<Complaint />} />
            <Route index element={<Home />} />
            <Route
              path="login-cadastro"
              element={<RedirectToLoginCadastro />}
            />

            <Route path="agendamento" element={<RedirectToAgendamento />} />
          </Routes>
        </BrowserRouter>
      </ContextProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
